// @flow
export const getDangerousHtml = (html: string) => ({
  __html: html,
})


// WEBPACK FOOTER //
// ./src/helpers/components.js